<template>
  <ul class="context-switcher">
    <li v-for="trip in contexts" :key="trip.id" :class="{active: trip.isActive}" class="trip-item">
      <button @click="onChangeContext(trip.id)">
        <div class="image-holder">
          <img :src="trip.img" :alt="trip.name" />
        </div>
        <div class="main-description">
          <p v-if="trip.isActive" class="active-text">
            Currently Viewing
          </p>
          <p v-else>
            View
          </p>

          <h4>{{ trip.name }}</h4>
        </div>
      </button>
    </li>
    <li class="trip-item" v-if="false">
      <button @click="onNewDestination(trip.id)">
        <div class="new-destination-holder" />
        <div class="main-description">
          <p>
            Add
          </p>

          <h4>New Destination</h4>
        </div>
      </button>
    </li>
  </ul>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
Vue.use(VueCompositionAPI);

export default defineComponent({
  name: 'context-switcher',
  components: {},
  props: {
    contexts: {
      type: Array,
      default: () => [],
    },
  },
  setup(_, {emit}) {
    const getName = (context) => {
      return context.name.replace('_', ', ');
    };

    const getImg = (context) => {
      const img = context.images.small;
      const fallback = context.oldImg?.length ? context.oldImg[0] : context.images[0];

      return img || fallback;
    };

    const onChangeContext = (selectedContext) => {
      emit('context-change', selectedContext);
    };

    const onNewDestination = () => {
      emit('new-destination');
    };

    return {
      getName,
      getImg,
      onChangeContext,
      onNewDestination,
    };
  },
});
</script>

<style scoped>
.context-switcher {
  border: none;
  padding: 10px 0 0;
  max-width: var(--page-container-width, 1260px);
  margin: 0 auto;
  width: 100%;
  display: flex;
  overflow-x: auto;
  overflow-y: visible;
  box-shadow: inset 0 -1px #e5e5e5;
  flex-shrink: 0;
}
.available-trips {
  overflow: auto;
  flex: 1;
  padding: 0;
  margin: 30px 0 0 0;
  width: 100%;
}

.trip-item {
  list-style: none;
  padding: 5px 10px 20px 0;
  position: relative;
  flex-shrink: 0;
}

.trip-item > button {
  display: flex;
  align-items: center;
  border: none;
  background: none;
  appearance: none;
  cursor: pointer;
  height: 40px;
}

.trip-item.active:after {
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  bottom: 0px;
  background: var(--primary-color, #2b70ca);
}

.image-holder {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
  overflow: hidden;
}

.new-destination-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #999999;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px dashed #cccccc;
  background-image: url(./icon-plus.svg);
  background-size: 12px;
  background-repeat: no-repeat;
  background-position: center;
}

.image-holder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.main-description {
  margin: 10px;
  flex: 1;
  text-align: left;
}

.main-description > h4 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: var(--font-color-dark);
  margin: 0;
}

.main-description > p {
  margin: 3px 0 0 0;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 98.1%;
  color: #858e9c;
}

.main-description > .active-text {
  color: var(--primary-color);
}
</style>
